import { useState } from "react";
import { exportApi } from "../api";
import { currentMonthRange } from "../time";

/** Экспорт в Excel (раздел 16.2): период создания лота, по умолчанию текущий месяц. Только admin (маршрут /export). */
export function ExportPage() {
  const [period, setPeriod] = useState(() => currentMonthRange());
  const valid = Boolean(period.from && period.to && period.from <= period.to);

  return (
    <>
      <div className="page-header">
        <h1>Экспорт в Excel</h1>
      </div>
      <section className="card export-card">
        <p className="muted" style={{ marginTop: 0 }}>
          Один файл .xlsx с листами <b>Лоты</b>, <b>Ставки</b>, <b>Перевозчики</b> и <b>К оплате</b> по заявкам, созданным за период.
          Даты в файле — в поясе Asia/Almaty.
        </p>
        <div className="filters">
          <label className="f">
            Создано с
            <input type="date" value={period.from} onChange={(e) => setPeriod((p) => ({ ...p, from: e.target.value }))} />
          </label>
          <label className="f">
            по
            <input type="date" value={period.to} onChange={(e) => setPeriod((p) => ({ ...p, to: e.target.value }))} />
          </label>
          <button type="button" className="btn" onClick={() => setPeriod(currentMonthRange())}>
            Текущий месяц
          </button>
          {valid ? (
            <a className="btn primary" href={exportApi.lotsXlsxUrl(period.from, period.to)}>
              Скачать Excel
            </a>
          ) : (
            <button type="button" className="btn primary" disabled title="Укажите период: дата «с» не позже даты «по»">
              Скачать Excel
            </button>
          )}
        </div>
        {!valid && <p className="error" style={{ marginBottom: 0 }}>Дата «с» должна быть не позже даты «по».</p>}
      </section>
    </>
  );
}
